import { defaultQueueMetricsParams } from '@/utils/metricsParams';
import { MetricsSection } from './MetricsSection';
import { api } from '@/store/api';
import { ADHERENCE_GROUPINGS } from '@/types/agentEvents';

const { useGetAbandonmentRateMetricsQuery } = api;

export function AbandonmentRateSection() {
  return (
    <MetricsSection
      titleKey="components.dashboard.abandonmentRate"
      descriptionKey="components.dashboard.abandonmentRateDescription"
      metricName="abandonment-rate"
      defaultParams={defaultQueueMetricsParams()}
      useQuery={useGetAbandonmentRateMetricsQuery}
      groupingsOptions={ADHERENCE_GROUPINGS}
      refreshLabelKey="components.dashboard.refreshAbandonmentRate"
    />
  );
}
